module.exports = __webpack_public_path__ + "img/login.72cd8a26.svg";